import { inject } from '@angular/core';
import { Auth, sendEmailVerification, user } from '@fido/firebase/auth';
import { CanActivateFn, Router } from '@angular/router';
import notify from 'devextreme/ui/notify';
import { firstValueFrom } from 'rxjs';

export const acceptInvitationEmailVerifiedGuard: CanActivateFn = async (route) => {
  const router = inject(Router);
  const auth = inject(Auth);
  const u = await firstValueFrom(user(auth));

  if (!u) {
    const returnUrl = route.url.map((segment) => segment.path).join('/');
    notify('Please sign in to continue.', 'warning', 3000);
    return router.createUrlTree(['/sign-in'], {
      queryParams: { returnUrl: `/${returnUrl}` },
    });
  }

  if (!u.emailVerified) {
    sendEmailVerification(u)
      .then(() => {
        notify(
          'A verification email has been sent. Please verify your email and return to this link.',
          'info',
          5000,
        );
      })
      .catch(() => {
        notify('Failed to send verification email. Please try again later.', 'error', 5000);
      });

    return false;
  }

  return true;
};
